export default "__VITE_ASSET__DaYNwUUX__"